import Udesk from 'Udesk';
import SdkLoaderBase from '../../../common/sdk-loader-base';
import UdeskLocales from 'UdeskLocales';

class SaleSentimentAnalysisComponent extends SdkLoaderBase {
    privates = {
        renderContainerId: "data-analysis-sale-sentiment-analysis",
        pageTitle: UdeskLocales.current.components.pages.saleSentimentAnalysis.title,
    };
}

export default Udesk.react.udeskify(SaleSentimentAnalysisComponent);
